import { render, staticRenderFns } from "./MacroWidget.vue?vue&type=template&id=6ab64c54&scoped=true"
import script from "./MacroWidget.vue?vue&type=script&lang=js"
export * from "./MacroWidget.vue?vue&type=script&lang=js"
import style0 from "./MacroWidget.vue?vue&type=style&index=0&id=6ab64c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab64c54",
  null
  
)

export default component.exports